<template>
  <div class="index" ref="index">
    <main-header></main-header>
    <div id="content" class="site-content global-layout-no-sidebar">
      <div class="container">
        <div class="inner-wrapper">
          <div id="primary" class="content-area">
            <div id="main" class="site-main">
              <div class="section section-featured-slider overlay-enabled">
                <!-- 轮播图 -->
				<div class="cycle-slideshow overlay-enabled featrued-slider">
					<div>
 					<div class="caption">
                      <div class="cycle-caption text-alignleft">
                        <h3>
                          <a href="#">
                            One Stop.<br/>Thousands Of<br/>Possibilities
                          </a>
                        </h3>
                      </div>
                    </div>
					<img src="../assets/images/slider/img_home_banner.jpg" alt="Slider" />
					</div>
					<!-- <swiper :options="swiperOption">
                      <swiper-slide>
                        <div class="caption">
                      <div class="cycle-caption text-alignleft">
                        <h4>We Are Creative & Digital Studio</h4>
                        <h3>
                          <a href="#">
                            Creative & Modern
                            <br />Agency Studio
                          </a>
                        </h3>
                        <div class="slider-buttons">
                          <a class="custom-button button-curved" href="#">About Us</a>
                        </div>
                      </div>
                    </div>
					<img src="../assets/images/slider/slide-3.jpg" alt="Slider" />
                      </swiper-slide>
                      <swiper-slide>
                        <div class="caption">
                      <div class="cycle-caption text-aligncenter">
                        <h4>We Are Creative & Digital Studio</h4>
                        <h3>
                          <a href="#">
                            Creative & Modern
                            <br />Agency Studio
                          </a>
                        </h3>
                        <div class="slider-buttons">
                          <a class="custom-button button-curved" href="#">About Us</a>
                        </div>
                      </div>
                    </div>
					<img src="../assets/images/slider/slide-2.jpg" alt="Slider" />
                      </swiper-slide>
                      <swiper-slide>
                        <div class="caption">
                      <div class="cycle-caption text-aligncenter">
                        <h4>We Are Creative & Digital Studio</h4>
                        <h3>
                          <a href="#">
                            Creative & Modern
                            <br />Agency Studio
                          </a>
                        </h3>
                        <div class="slider-buttons">
                          <a class="custom-button button-curved" href="#">About Us</a>
                        </div>
                      </div>
                    </div>
					<img src="../assets/images/slider/slide-1.jpg" alt="Slider" />
                      </swiper-slide>
                      <swiper-slide>
                        <div class="caption">
                      <div class="cycle-caption text-alignleft">
                        <h4>We Are Creative & Digital Studio</h4>
                        <h3>
                          <a href="#">
                            Creative & Modern
                            <br />Agency Studio
                          </a>
                        </h3>
                        <div class="slider-buttons">
                          <a class="custom-button button-curved" href="#">About Us</a>
                        </div>
                      </div>
                    </div>
					<img src="../assets/images/slider/slide-4.jpg" alt="Slider" />
                      </swiper-slide>
                    <div class="swiper-button-prev  button-circle"><</div>
                    <div class="swiper-button-next button-circle">></div>
				    <div class="swiper-pagination"></div>
					</swiper> -->
				</div>
              </div>
              <!-- About Company -->
              <div class="section">
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">Who We Are ?</h2>
                    <span class="divider"></span>
                  </div>
                  <div>
                    <div class="col-grid-7">
                      <div>
						<p><span class="color272727">Pearl River Engineering Pte. Ltd.</span>(Singapore), founded in 2015, is a registered company under Beijing Just Truth Investment Holding Co. Ltd. The company relies on modern, automatic customized intelligent factory, and applies the advanced mode of "factory customization, site assembly", aims to provide high-standard customized engineering products and solutions for luxury hotels, apartments, high-end office buildings and other project customers.</p>
                      </div>
                      <div>
						  <p>We fully integrate the corporate culture with the local market of Singapore, and form a complete set of closed-loop service chain from design to production, installation to maintenance. Under the unremitting efforts, our business has extended to many countries in Southeast Asia.</p>
                      </div>
					  <div>
						  <p>In 2019, Pearl River Engineering Co., LTD. (Cambodia) was established.</p>
					  </div>
					  <div>
						  <p>In 2020, the company registered a brand new furniture brand Homing. We signed a famous Italian design team as the exclusive designer of HOMING. We are determined to deliver the concept of “simple but not vulgar, elegant but not numerous, luxury but not exposed" to more people.</p>
					  </div>
                    </div>
                    <div class="col-grid-5">
                      <img src="../assets/images/index/1.jpg" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- Intelligent Manufacturing -->
              	<div class="section section-services lite-background service-layout-1">
					<div class="container">
						<div class="section-title-wrap">
							<h2 class="section-title">Intelligent Manufacturing</h2>
							<span class="divider"></span>
							<p class="section-subtitle">The fully automatedproduction line-The Industry 4.0</p>
						</div>
						<div class="service-block-list">
							<div class="inner-wrapper">
								<div class="col-grid-4 service-block-item">
									<div class="service-block-inner box-shadow-block">
										<div class="service-icon">
											<svg width="65px" height="65px" viewBox="0 0 65 65"  xmlns:xlink="http://www.w3.org/1999/xlink">
												<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="Page1-Home" transform="translate(-518.000000, -1714.000000)">
														<g id="Part-3" transform="translate(0.000000, 1406.000000)">
															<g id="card1" transform="translate(370.000000, 259.000000)">
																<g id="icon_More_Efficient" transform="translate(148.000000, 49.000000)">
																	<g id="编组" fill="#EBF6FF">
																		<path d="M0,32.5102131 C0,50.4534072 14.5447482,64.999992 32.4872236,64.999992 C50.4293796,64.999992 64.9759644,50.4542856 64.9759644,32.5111714 C64.9759644,14.5686959 50.4303378,0.0230694103 32.4872236,0.0230694103 C14.5456265,0.0221111794 0,14.5677377 0,32.5102131" id="Fill-1"></path>
																	</g>
																	<path d="M40.9621742,30.9871197 C39.7671513,32.1887878 37.9608984,32.5536109 36.3888922,31.9112068 C34.816886,31.2714845 33.8166986,29.7074387 33.8166986,28.0016442 C33.8166986,26.2958498 34.816886,24.7318039 36.3888922,24.0921606 C37.9608984,23.4496776 39.7671513,23.8145007 40.9621742,25.0162476 C42.6048351,26.6511283 42.6048351,29.3521601 40.9621742,30.9871197 M49.4656304,17.4815663 C49.4074256,16.9974756 49.0236226,16.6154566 48.5367321,16.5574793 C40.3906726,14.6384704 31.9587433,17.76601 27.0273509,24.5185895 C26.8532915,24.7610687 26.6011234,24.9370514 26.3127954,25.0171153 C23.4543355,25.7279879 20.8105357,27.2196213 18.7382376,29.3521601 C17.737733,30.3474764 16.8802823,31.4135486 16.1657268,32.6220004 C15.5942251,33.6178689 16.5944125,34.8263996 17.737733,34.3999707 C19.5240821,33.7602485 21.4535643,33.4037867 23.3115196,33.4037867 C23.3115196,33.5460875 23.2399927,33.7602485 23.2399927,33.9023914 C24.6121676,35.4938089 26.0423095,37.0347427 27.5273256,38.5226688 C29.0281221,40.0153276 30.5286014,41.436915 32.1015592,42.7875098 C32.2446131,42.7875098 32.4589559,42.7162806 32.6017719,42.7162806 C32.6017719,44.6356049 32.3159021,46.4828324 31.6012673,48.2607238 C31.387876,48.7608272 31.5337053,49.3410734 31.9587433,49.6821534 C32.387429,50.0377474 32.9592479,50.1089767 33.3879336,49.824533 C34.6025431,49.1136604 35.6745746,48.2607238 36.6748413,47.2655653 C38.7470601,45.2040979 40.2478566,42.5742165 41.0337012,39.6590236 C41.1053074,39.3756054 41.2471717,39.0911617 41.5339931,38.94823 C48.250783,34.0443766 51.3245373,25.5850561 49.4656304,17.4815663" id="Fill-3" fill="#0095DD"></path>
																	<path d="M21.1408635,37.5609706 C19.6678645,38.6496548 13.8969597,46.7458013 15.1863868,48.6036301 C16.4762087,50.4611328 24.3098492,45.2472816 25.783954,44.1591678 C27.2560841,43.0703206 27.417065,40.7158648 26.127559,38.8583621 C24.8381319,37.0009408 22.6140994,36.4726939 21.1408635,37.5609706" id="Fill-5" fill="#F6D224"></path>
																</g>
															</g>
														</g>
													</g>
												</g>
											</svg>
										</div>
										<div class="service-block-inner-content">
											<h3 class="service-item-title">More Efficient</h3>
											<div>
												<p>3D measurement and modeling based on actual data of field to achieve high efficiency and precision.</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-grid-4 service-block-item">
									<div class="service-block-inner box-shadow-block">
										<div class="service-icon">
											<svg  width="64px" height="64px" viewBox="0 0 64 64" xmlns:xlink="http://www.w3.org/1999/xlink">
											<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g id="Page1-Home" transform="translate(-928.000000, -1725.000000)">
													<g id="Part-3" transform="translate(0.000000, 1406.000000)">
														<g id="card2" transform="translate(780.000000, 270.000000)">
															<g id="icon_Lower" transform="translate(148.000000, 49.000000)">
																<path d="M31.9874201,63.9772305 C49.653543,63.9772305 63.9763342,49.6553828 63.9763342,31.9883165 C63.9763342,14.3218005 49.6544865,3.14496315e-05 31.9874201,3.14496315e-05 C14.3218477,-0.000990663391 0,14.3209356 0,31.987373 C0,49.6544393 14.3209828,63.9772305 31.9874201,63.9772305 Z" id="Fill-1" fill="#EBF6FF"></path>
																<path d="M31.7125268,15.8750034 C31.764969,15.8750034 31.8345514,15.8582565 31.904055,15.8047921 C32.0611459,15.7009297 32.2522811,15.5267774 32.5131558,15.2659813 C32.8263941,14.9880452 33.122571,14.7796914 33.4354162,14.6576668 C33.7476324,14.5359568 34.1482221,14.5702369 34.6528314,14.7786693 C34.9136275,14.8491951 35.1052344,14.969883 35.2611459,15.1100698 C35.4180796,15.2488413 35.5573229,15.3876128 35.6960943,15.5096373 C35.835259,15.6313474 35.9921926,15.753372 36.1491263,15.8400943 C36.322571,15.9274457 36.5320256,15.9788658 36.7746595,15.9788658 C37.0364776,15.9788658 37.2448314,15.9445857 37.4189052,15.8582565 L37.9405759,15.6484088 C38.0964875,15.5792197 38.2710329,15.5449396 38.4440845,15.5096373 C38.6182369,15.4924973 38.8097651,15.5096373 39.0362811,15.5801631 C39.2970771,15.6837897 39.4530673,15.8229543 39.5579518,16.0141681 C39.6443597,16.2053818 39.6796619,16.3966742 39.6281631,16.6054211 C39.5929396,16.8147971 39.5055096,17.0060108 39.366345,17.2144432 C39.228517,17.4157209 39.0510624,17.5871214 38.8447528,17.7178732 C38.3573622,18.0322123 37.9919961,18.3282319 37.7312,18.6582958 C37.4704039,18.9705907 37.2276914,19.3191312 36.9658732,19.6672786 C36.8451853,19.8404088 36.7050771,20.0501779 36.5491656,20.2756717 C36.3918388,20.5022663 36.2529887,20.7287037 36.1309641,20.9541975 C35.9750526,21.2322123 35.8189838,21.4930084 35.6274555,21.7548265 L27.7471214,21.7548265 C27.5731263,21.4416668 27.3988953,21.16263 27.2073671,20.8846939 C27.0520845,20.6218536 26.8840649,20.3664039 26.704173,20.1192885 C26.5297848,19.8574703 26.3727725,19.6319764 26.2507479,19.4408413 C26.0044187,19.0744531 25.7187774,18.7362909 25.3990919,18.4317799 C25.1033081,18.1507774 24.7894408,17.8892737 24.4596914,17.649313 C24.1302565,17.4254703 23.8903744,17.0927332 23.7806939,16.7099125 C23.6600845,16.3102663 23.7635538,15.9788658 24.129313,15.7009297 C24.3073966,15.5792197 24.522512,15.5237897 24.7373916,15.5449396 C24.9641435,15.5621582 25.2078781,15.6145219 25.4686742,15.7009297 C25.7301779,15.7714555 25.9717897,15.8582565 26.2165464,15.9274457 C26.460517,15.997028 26.6860894,16.0141681 26.8773032,15.9617258 C27.2254506,15.8921435 27.5034654,15.753372 27.6779322,15.5621582 C27.8520059,15.3708658 28.1643007,15.1439568 28.5991705,14.8491951 C28.9298634,14.6395047 29.3285661,14.5645759 29.7127233,14.6395047 C30.1126054,14.7100305 30.4256079,14.8310329 30.6343548,15.0404875 C30.7388462,15.1610968 30.8436521,15.2841435 30.9653622,15.3708658 C31.0864432,15.4572737 31.2080747,15.5449396 31.3300993,15.6145219 C31.4174506,15.7009297 31.5565366,15.8058143 31.7125268,15.8750034" id="Fill-3" fill="#0095DD"></path>
																<path d="M36.1970555,23.4281356 C36.5039253,23.8372167 36.8873749,24.2846663 37.3475617,24.7703273 C37.7310113,25.2049612 38.2039351,25.6969907 38.7664118,26.2467302 C39.3288885,26.7963912 39.9807607,27.3780521 40.7220285,27.9915558 C41.3356894,28.528401 41.968456,29.1612462 42.6203283,29.8897769 C43.2723577,30.6184649 43.8411243,31.4685484 44.3269425,32.4399489 C44.8126034,33.411428 45.1514732,34.5300128 45.3430801,35.7953101 C45.5349229,37.0609219 45.5029229,38.4733248 45.2472373,40.0329907 C45.0172619,41.3111037 44.5633651,42.519084 43.88594,43.6568531 C43.2083577,44.7945435 42.3072472,45.7850496 41.1822939,46.6287646 C40.0574192,47.4724796 38.7215961,48.1436147 37.1749818,48.6420914 C35.6282103,49.1405681 33.870569,49.3898064 31.902058,49.3898064 C29.8824413,49.3898064 28.0928,49.1023568 26.5332914,48.5270644 C24.9737828,47.9518506 23.6507754,47.2041356 22.5641907,46.2836049 C21.4776845,45.3633101 20.6149425,44.3342781 19.975886,43.1965877 C19.3365936,42.0589759 18.9146968,40.9276541 18.7102742,39.802858 C18.4802988,38.5501405 18.4482988,37.3485287 18.6145101,36.1980226 C18.7804855,35.0476737 19.0809867,33.9674575 19.5156206,32.9576098 C19.9502545,31.9479194 20.4935469,31.0211774 21.1454978,30.1773838 C21.79737,29.3337474 22.5067951,28.5796639 23.273773,27.9148973 C23.9383823,27.3268678 24.5393061,26.7707597 25.0761514,26.2467302 C25.6129966,25.7226221 26.0602889,25.2433297 26.418343,24.8086958 C26.8528197,24.3230349 27.2364265,23.8627695 27.5686919,23.4281356 L36.1970555,23.4281356 Z" id="Fill-5" fill="#0095DD"></path>
																<path d="M34.0285641,41.6712649 C33.6570654,41.851943 33.2578123,41.9740462 32.8329278,42.14183 C32.8329278,42.6226162 32.8405543,43.128798 32.8329278,43.6298693 C32.8252226,43.945545 32.8151587,43.9630781 32.4945297,43.9734565 C32.0469229,43.9860364 31.5992373,43.9709405 31.1539106,43.9684246 C31.0444658,43.9684246 30.9885641,43.9148029 30.9810162,43.813142 C30.9606526,43.5690143 30.9428049,43.3248079 30.937773,43.0805229 C30.9302251,42.8108423 30.935257,42.5385671 30.935257,42.2589799 C30.5332521,42.1876678 30.1364364,42.1265769 29.7419794,42.045201 C29.1721907,41.9256924 28.6177337,41.7627833 28.1470113,41.3963951 C28.0987361,41.3584197 28.0503823,41.266744 28.065714,41.2183902 C28.2285445,40.6206899 28.4089867,40.0226752 28.5847115,39.4274123 C28.5897435,39.4020167 28.6050752,39.3816531 28.6280334,39.343599 C28.8084757,39.4172698 28.9891538,39.4936138 29.1670801,39.5648472 C29.8743823,39.8547342 30.5967803,40.0939086 31.3702054,40.122056 C31.8433651,40.1371518 32.3011931,40.1067243 32.703198,39.8117268 C33.4028737,39.2952452 33.4282693,38.4480708 32.723483,37.9418889 C32.4285641,37.7282673 32.074913,37.5857219 31.7391096,37.4355499 C31.125999,37.160916 30.4849769,36.9395892 29.89223,36.6241494 C29.1442005,36.2298496 28.5567214,35.6497612 28.2894781,34.8154025 C27.8316501,33.3832649 28.4192865,31.8924737 29.7472472,31.1369749 C30.1059302,30.9360118 30.5079351,30.8112354 30.8970457,30.6712845 C31.0165543,30.6281985 31.0547656,30.5874713 31.0547656,30.467884 C31.0598762,30.0073828 31.0726919,29.5495548 31.0827558,29.0891322 C31.0877877,28.9083754 31.1668049,28.8347047 31.3422152,28.8397366 C31.7950113,28.8524737 32.247886,28.8651322 32.7006034,28.8626162 C32.8813602,28.8626162 32.9346673,28.9593238 32.9422939,29.1043066 C32.9575469,29.325712 32.9626575,29.5444442 32.9676894,29.7656924 C32.9704413,29.9285229 32.9676894,30.0938693 32.955031,30.2566998 C32.9422939,30.4170929 32.9958369,30.4779479 33.1636993,30.5059381 C33.8224118,30.6179774 34.4838762,30.7223115 35.0894388,31.0299676 C35.4506378,31.2131617 35.4506378,31.2106457 35.3463823,31.610056 C35.2114634,32.1391961 35.0894388,32.6735253 34.817085,33.1821445 C34.725488,33.1414172 34.6366428,33.1059577 34.5475617,33.0675892 C33.769026,32.7548226 32.9651735,32.5386064 32.1232668,32.5563754 C31.8637287,32.561486 31.5914536,32.6098398 31.3498418,32.7039528 C30.7621268,32.9329061 30.5866378,33.6757464 30.9835322,34.1668324 C31.2176747,34.4567194 31.5330359,34.6270978 31.8637287,34.7720806 C32.5455568,35.06983 33.2425592,35.3293681 33.9114929,35.6522771 C34.5933209,35.9780167 35.1732521,36.4436285 35.5346084,37.1304098 C36.2570064,38.5193042 36.0458221,40.6816236 34.0285641,41.6712649" id="Fill-7" fill="#F6D224"></path>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
										</div>
										<div class="service-block-inner-content">

											<h3 class="service-item-title">Lower Costs
											</h3>
											<div>
												<p>Wild source of supplies to provide competitive and attractive price.</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-grid-4 service-block-item">
									<div class="service-block-inner box-shadow-block">
											<div class="service-icon">
										<svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g id="Page1-Home" transform="translate(-1338.000000, -1726.000000)">
													<g id="Part-3" transform="translate(0.000000, 1406.000000)">
														<g id="card3" transform="translate(1190.000000, 270.000000)">
															<g id="icon_Digital" transform="translate(148.000000, 50.000000)">
																<g id="编组" transform="translate(0.000000, 0.055902)">
																	<mask id="mask-2" fill="white">
																		<use xlink:href="#path-1"></use>
																	</mask>
																	<g id="Clip-2"></g>
																	<path d="M-1.57248157e-05,32.010056 C-1.57248157e-05,49.677201 14.3209671,63.9999921 31.9874044,63.9999921 C49.6535273,63.9999921 63.9763184,49.6780658 63.9763184,32.0109995 C63.9763184,14.3445622 49.6544708,0.0227144963 31.9874044,0.0227144963 C14.3218319,0.0217710074 -1.57248157e-05,14.3436187 -1.57248157e-05,32.010056" id="Fill-1" fill="#EBF6FF" mask="url(#mask-2)"></path>
																</g>
																<path d="M20.5924324,45.8786123 L41.464688,45.8786123 C42.1895233,45.8786123 42.5522162,46.2413052 42.5522162,46.966455 L42.5522162,47.3409415 C42.5522162,48.0659342 42.1895233,48.4284698 41.464688,48.4284698 L20.5924324,48.4284698 C19.8673612,48.4284698 19.5039607,48.0659342 19.5039607,47.3409415 L19.5039607,46.966455 C19.5039607,46.2413052 19.8673612,45.8786123 20.5924324,45.8786123" id="Fill-3" fill="#F6D224"></path>
																<path d="M38.2478781,31.377769 C38.0752983,31.5479115 37.8292835,31.6212678 37.5915243,31.5733857 C37.3538437,31.5254251 37.1557111,31.3623587 37.0626988,31.138516 L33.9619224,23.6255921 L28.6683204,37.009769 C28.5584039,37.2886486 28.2887233,37.472 27.9889297,37.4713726 C27.6889002,37.4708206 27.4198486,37.2865258 27.3111115,37.0070172 L23.7291558,27.7871646 L19.6225415,34.0994988 C19.4855784,34.3279803 19.2343744,34.4637641 18.9677602,34.452688 C18.7014604,34.4419066 18.4622074,34.286231 18.3439568,34.0472924 C18.2260206,33.8080393 18.2481926,33.5233415 18.4017455,33.3052383 L23.2828855,25.8006486 C23.4317995,25.5712236 23.6969199,25.4444029 23.9692737,25.4723145 C24.2413916,25.5006192 24.4748265,25.6790172 24.5737356,25.934231 L27.9975784,34.7453956 L33.2718388,21.4127174 C33.3811263,21.1369828 33.6467971,20.9548108 33.9435243,20.952688 L33.949028,20.952688 C34.2444973,20.952688 34.5101681,21.1302211 34.6234654,21.4025749 L37.9984826,29.5807371 L42.470227,25.1695332 C42.7573622,24.8906536 43.2155833,24.8952138 43.4966644,25.1799115 C43.7779813,25.464688 43.7770378,25.9229091 43.4944629,26.2063489 L38.2478781,31.377769 Z M44.4045366,17.1799115 L17.6517504,17.1799115 C16.0254899,17.1799115 14.7073572,18.4984373 14.7073572,20.1243833 L14.7073572,39.3439607 C14.7073572,40.9701425 16.0254899,42.2883538 17.6517504,42.2883538 L44.4045366,42.2883538 C46.0304039,42.2883538 47.3489297,40.9701425 47.3489297,39.3439607 L47.3489297,20.1261916 C47.3489297,18.5000098 46.0307184,17.1811695 44.4045366,17.1799115 L44.4045366,17.1799115 Z" id="Fill-5" fill="#0095DD"></path>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
										</div>
										<div class="service-block-inner-content">
											<h3 class="service-item-title">Digital Control Form
											</h3>
											<div>
												<p>Automatic controlled by computer program to ensure the quality of product.</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-grid-4 service-block-item">
									<div class="service-block-inner service-block-inner_f box-shadow-block">
											<div class="service-icon">
												<svg width="64px" height="65px" viewBox="0 0 64 65" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
													<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<g id="Page1-Home" transform="translate(-509.000000, -2125.000000)">
															<g id="Part-3" transform="translate(0.000000, 1406.000000)">
																<g id="card4" transform="translate(370.000000, 668.000000)">
																	<g id="icon_Fulfils" transform="translate(139.000000, 51.000000)">
																		<path d="M-7.86240785e-06,32.0659577 C-7.86240785e-06,49.7331027 14.3209749,64.0558939 31.9874123,64.0558939 C49.6535351,64.0558939 63.9763263,49.7339676 63.9763263,32.0669012 C63.9763263,14.4004639 49.6544786,0.0786162162 31.9874123,0.0786162162 C14.3218398,0.0776727273 -7.86240785e-06,14.3995204 -7.86240785e-06,32.0659577" id="Fill-1" fill="#EBF6FF"></path>
																		<path d="M23.8378693,21.6224629 L23.8378693,21.9351509 L19.4155004,25.6249789 L19.4155004,21.6224629 C19.4152649,21.3218044 19.5340658,21.0334113 19.7462722,20.8205759 C19.9585572,20.6077405 20.2469504,20.4883106 20.5472943,20.4879961 L22.7042673,20.4879961 C23.3298791,20.4879961 23.8378693,20.9959862 23.8378693,21.6224629 L23.8378693,21.6224629 Z M27.5890241,34.4785219 L27.6443754,32.288684 C27.6443754,32.0309543 27.4419184,31.8286545 27.1842673,31.8286545 L24.644631,31.8286545 C24.3869799,31.8286545 24.1845775,32.0309543 24.1845775,32.288684 L24.1845775,34.4785219 C24.1833435,34.6007037 24.23154,34.7186398 24.3178693,34.8052049 C24.404513,34.8916128 24.5224491,34.9397307 24.644631,34.9385725 L27.1289946,34.9385725 C27.3866457,34.9385725 27.5890241,34.7360943 27.5890241,34.4785219 L27.5890241,34.4785219 Z M42.0838447,35.2622467 C41.8473435,35.2219912 41.6084049,35.1974604 41.3688373,35.1888118 L40.545486,33.8823941 C40.2048079,33.9142369 39.8645229,33.9759568 39.5276187,34.061657 C39.3123459,34.1155145 39.1006899,34.182345 38.8937514,34.2623057 L38.7152747,35.8053032 C38.2939283,36.0221484 37.9038742,36.2945022 37.5549405,36.6148953 L36.0470093,36.2607725 C35.681486,36.6949346 35.3746948,37.1750919 35.1341838,37.6889002 L36.0863214,38.9105612 C35.9327686,39.3799469 35.843373,39.8676521 35.8215155,40.3607823 L34.5036973,41.1879862 C34.5359332,41.542345 34.5967096,41.9001631 34.6861052,42.2554654 C34.7365032,42.4449494 34.7935843,42.6344334 34.8581346,42.816684 L36.3983017,43.0180403 C36.5107342,43.238974 36.6357464,43.4504727 36.7736531,43.6501022 L20.3974369,43.6501022 C20.1470978,43.6507283 19.9072157,43.5515833 19.7303115,43.374915 C19.5534074,43.1980108 19.4539479,42.9582074 19.4542624,42.7082614 L19.4542624,30.7241435 L19.2555007,30.8899617 C18.6176236,31.3921337 17.696228,31.2993572 17.1716482,30.6796423 C16.6468324,30.0599273 16.7069799,29.1360943 17.3074319,28.589657 L29.5967686,18.1848609 C29.9213287,17.9096767 30.347314,17.7846644 30.7690536,17.8405661 C31.1784491,17.7864727 31.6062428,17.9013425 31.9403951,18.1848609 L44.2294172,28.5905219 C44.8252305,29.1378241 44.8829405,30.0577258 44.3602477,30.6753179 C43.8375548,31.2929101 42.9207194,31.3878093 42.2825278,30.8909052 L42.0838447,30.7241435 L42.0838447,35.2622467 Z" id="Fill-3" fill="#0095DD"></path>
																		<path d="M41.8141877,42.9526251 C42.6624629,42.7346791 43.3295882,42.0804482 43.564517,41.2367332 C43.7997602,40.3930968 43.5666398,39.4882909 42.9536079,38.8626791 C42.3406545,38.2373818 41.4404088,37.9867283 40.5924482,38.2048314 C39.281313,38.5423646 38.4920059,39.8786595 38.8292246,41.189716 C39.1667577,42.5008511 40.5030526,43.2901582 41.8141877,42.9526251 L41.8141877,42.9526251 Z M45.5728118,40.7536668 C45.5546496,41.1585022 45.4827872,41.5506005 45.3602909,41.9352295 L46.1342663,42.9272295 C45.938571,43.3445661 45.6894899,43.7346201 45.3925268,44.0872491 L44.1680354,43.799485 C43.8842025,44.0598093 43.5672688,44.2809789 43.2248609,44.4573327 L43.0795636,45.7103646 C42.910915,45.7748364 42.741716,45.8301877 42.5641828,45.8742958 C42.2908855,45.9430919 42.0147577,45.993883 41.73863,46.0195931 L41.0669445,44.9541582 C40.6667479,44.940399 40.2703253,44.8721533 39.8885268,44.7514654 L38.8900796,45.5300796 C38.4782467,45.3387872 38.0921238,45.0964678 37.7408314,44.8086251 L38.0150722,43.5785514 C37.7279371,43.27577 37.4867971,42.9324187 37.2991214,42.5598192 L36.0478978,42.3971459 C35.9953769,42.2468953 35.9490673,42.0945219 35.9088118,41.9406545 C35.8366349,41.6559568 35.7868658,41.3663843 35.7598192,41.0739813 L36.8307577,40.4022958 C36.8486054,40.0014703 36.9210968,39.6046545 37.0461091,39.2235636 L36.2724482,38.231485 C36.4674359,37.8120256 36.7177749,37.4255882 37.0138732,37.0703646 L38.2386791,37.3584432 C38.5221189,37.0981975 38.8393671,36.8774211 39.1818536,36.7014604 L39.3270722,35.4474064 C39.7592688,35.2877995 40.2100993,35.1842516 40.6686349,35.1390428 L41.3366251,36.2007823 C41.7442123,36.2155636 42.1373327,36.2855391 42.5144138,36.4041042 L43.5129396,35.6250182 C43.9268953,35.8171754 44.3105022,36.0574506 44.6631312,36.3464727 L44.38606,37.5763892 C44.6710722,37.8764973 44.9093818,38.2168609 45.1020108,38.5951214 L46.3532344,38.7579518 C46.5021484,39.1861386 46.5989346,39.6307577 46.641313,40.0819813 L45.5728118,40.7536668 Z" id="Fill-5" fill="#F6D224"></path>
																		<path d="M39.943485,40.5817002 C39.9312197,41.0429091 40.1701582,41.4744767 40.5679174,41.708855 C40.9652835,41.9430762 41.4588855,41.9430762 41.8562516,41.708855 C42.2536963,41.4744767 42.4929494,41.0429091 42.4803695,40.5817002 C42.4618929,39.8943686 41.8995735,39.3470663 41.2119273,39.3470663 C40.5245956,39.3470663 39.9622762,39.8943686 39.943485,40.5817002" id="Fill-7" fill="#F6D224"></path>
																	</g>
																</g>
															</g>
														</g>
													</g>
												</svg>
											</div>
										<div class="service-block-inner-content">
											<h3 class="service-item-title">Fulfils Customisable Demands</h3>
											<div class="service-block-item-excerpt">
												<p>With the modular solution to fully realize the characteristics of customization.</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-grid-4 service-block-item">
									<div class="service-block-inner box-shadow-block">
										<div class="service-icon">
											<svg width="64px" height="64px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<defs>
													<polygon id="path-1" points="0 0.022710184 63.9763263 0.022710184 63.9763263 63.9214724 0 63.9214724"></polygon>
												</defs>
												<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="Page1-Home" transform="translate(-928.000000, -2123.000000)">
														<g id="Part-3" transform="translate(0.000000, 1406.000000)">
															<g id="card5" transform="translate(780.000000, 668.000000)">
																<g id="icon_Intelligent" transform="translate(148.000000, 49.000000)">
																	<g id="编组" transform="translate(0.000000, 0.055833)">
																		<mask id="mask-2" fill="white">
																			<use xlink:href="#path-1"></use>
																		</mask>
																		<g id="Clip-2"></g>
																		<path d="M-7.86240786e-06,31.9708034 C-7.86240786e-06,49.6162709 14.3209749,63.9214881 31.9874123,63.9214881 C49.6535351,63.9214881 63.9763263,49.6171347 63.9763263,31.9717458 C63.9763263,14.326985 49.6544786,0.022710184 31.9874123,0.022710184 C14.3218398,0.0217678528 -7.86240786e-06,14.3260427 -7.86240786e-06,31.9708034" id="Fill-1" fill="#EBF6FF" mask="url(#mask-2)"></path>
																	</g>
																	<path d="M44.120059,33.446345 C44.320629,32.5585119 43.6038133,32.0073266 42.7564816,32.0073266 C42.0045995,32.0073266 41.1258968,32.1975205 40.4303096,32.895945 C39.4284029,31.5972555 38.3986634,31.7546248 36.3918624,32.9766714 C35.7521769,33.369545 35.1056511,33.7509536 34.4523636,34.1208187 C34.3187813,34.194399 34.2094939,34.2505463 34.1044521,34.3064579 C34.3013268,34.345015 34.5009533,34.3800383 34.7189779,34.3800383 C37.534742,34.3800383 39.7586241,34.3800383 39.7586241,36.7815696 C39.7586241,38.627518 37.5798722,39.1578935 36.4241769,39.1791745 L31.2088845,39.1791745 C29.0611106,39.1791745 26.9561081,36.9782027 26.9561081,36.9782027 C26.9561081,36.9782027 29.4403931,37.9779377 31.2088845,37.9779377 L36.4093956,37.9779377 C36.4204816,37.9779377 38.535941,37.8944628 38.535941,36.7815696 C38.535941,35.7595328 37.966231,35.5812751 34.7189779,35.5812751 C32.6001376,35.5812751 30.4597543,34.3524751 30.4597543,34.3524751 C30.4597543,34.3524751 28.3160688,32.8150616 27.659086,32.407896 C26.1022506,31.4520579 24.8581032,30.5441217 22.1381818,31.5972555 C20.4158428,32.2637193 16.6486486,33.986772 16.6486486,33.986772 C16.2447568,34.2607548 16.4867617,35.5913266 17.3737985,37.9779377 C18.2598133,40.3647058 19.1762555,41.5582469 20.1203735,41.5582469 L21.8916167,40.427842 C22.8725307,39.817761 23.4133857,39.7122984 24.6797052,40.3508849 C25.9050614,40.968426 29.6695037,42.8962788 30.6108698,43.3447499 C33.5036855,44.7241659 34.7438231,43.4892407 36.1425455,42.6960334 C37.334172,42.0214027 45.7791843,36.5251769 46.6688943,35.9073217 C48.04914,34.9490493 48.4815725,34.1097463 47.849199,33.3030321 C47.3710074,32.6920088 46.2988108,32.1828358 44.120059,33.446345" id="Fill-3" fill="#0095DD"></path>
																	<path d="M39.8444973,28.4604231 L39.8444973,20.3808746 C39.8444973,19.4113728 38.7926644,19.483147 38.7926644,19.483147 L32.8600059,19.483147 C32.5233376,19.483147 32.3130182,19.3395985 32.3130182,19.3395985 C32.3130182,19.3395985 32.0605563,18.9804133 31.5976963,18.4059053 C31.1769789,17.7595445 30.6299912,17.8672844 30.6299912,17.8672844 L26.04377,17.8672844 C24.7393966,17.8672844 24.7393966,18.908639 24.7393966,18.908639 L24.7393966,28.3886488 C24.7393966,29.5736304 25.7912295,29.4300034 25.7912295,29.4300034 L38.918856,29.4300034 C40.0129101,29.4300034 39.8444973,28.4604231 39.8444973,28.4604231 M36.3943941,26.3777924 L31.3452344,26.3777924 C30.924517,26.3777924 30.5879273,26.0904599 30.5879273,25.7313531 C30.5879273,25.3722464 30.924517,25.0849924 31.3452344,25.0849924 L36.3943941,25.0849924 C36.8151115,25.0849924 37.1517012,25.3722464 37.1517012,25.7313531 C37.1517012,26.0904599 36.8151115,26.3777924 36.3943941,26.3777924 M27.7688609,23.1817973 C27.7688609,23.5768697 28.1054506,23.8640452 28.5682319,23.8640452 C29.0310919,23.8640452 29.3677602,23.5409826 29.3677602,23.1817973 C29.3677602,22.8227691 29.0310919,22.4994709 28.5682319,22.4994709 C28.1054506,22.4994709 27.7688609,22.8227691 27.7688609,23.1817973 M27.7688609,25.7313531 C27.7688609,26.1264255 28.1054506,26.4136795 28.5682319,26.4136795 C29.0310919,26.4136795 29.3677602,26.0904599 29.3677602,25.7313531 C29.3677602,25.3722464 29.0310919,25.0491053 28.5682319,25.0491053 C28.1054506,25.0491053 27.7688609,25.3363593 27.7688609,25.7313531 M36.3943941,23.828158 L31.3452344,23.828158 C30.924517,23.828158 30.5879273,23.5409826 30.5879273,23.1817973 C30.5879273,22.8227691 30.924517,22.5354366 31.3452344,22.5354366 L36.3943941,22.5354366 C36.8151115,22.5354366 37.1517012,22.8227691 37.1517012,23.1817973 C37.1517012,23.5409826 36.8151115,23.828158 36.3943941,23.828158" id="Fill-5" fill="#F6D224"></path>
																</g>
															</g>
														</g>
													</g>
												</g>
											</svg>
										</div>
										<div class="service-block-inner-content">
											<h3 class="service-item-title">Intelligent Delivery
											</h3>
											<div>
												<p>Multiplexing • multiple board</br> • multiple control</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-grid-4 service-block-item service-item-6">
									<div class="service-block-inner box-shadow-block">
										<div class="service-icon">
										<svg width="64px" height="64px" viewBox="0 0 64 64"  xmlns:xlink="http://www.w3.org/1999/xlink">
												<defs>
													<polygon id="path-1" points="0 0.022710184 63.9763263 0.022710184 63.9763263 63.9214724 0 63.9214724"></polygon>
												</defs>
												<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
													<g id="Page1-Home" transform="translate(-1338.000000, -2123.000000)">
														<g id="Part-3" transform="translate(0.000000, 1406.000000)">
															<g id="card6" transform="translate(1190.000000, 668.000000)">
																<g id="icon_Safety-" transform="translate(180.000000, 81.500000) scale(-1, 1) translate(-180.000000, -81.500000) translate(148.000000, 49.000000)">
																	<g id="编组" transform="translate(0.000000, 0.055833)">
																		<mask id="mask-2" fill="white">
																			<use xlink:href="#path-1"></use>
																		</mask>
																		<g id="Clip-2"></g>
																		<path d="M-7.86240786e-06,31.9708034 C-7.86240786e-06,49.6162709 14.3209749,63.9214881 31.9874123,63.9214881 C49.6535351,63.9214881 63.9763263,49.6171347 63.9763263,31.9717458 C63.9763263,14.326985 49.6544786,0.022710184 31.9874123,0.022710184 C14.3218398,0.0217678528 -7.86240786e-06,14.3260427 -7.86240786e-06,31.9708034" id="Fill-1" fill="#EBF6FF" mask="url(#mask-2)"></path>
																	</g>
																	<path d="M43.4876147,21.2525232 C45.0692953,21.2525232 46.3515754,19.9718164 46.3515754,18.391998 C46.3515754,16.8122582 45.0692953,15.5315514 43.4876147,15.5315514 C41.9060128,15.5315514 40.6238113,16.8122582 40.6238113,18.391998 C40.6238113,19.9718164 41.9060128,21.2525232 43.4876147,21.2525232" id="Fill-3" fill="#F6D224"></path>
																	<path d="M44.1177789,44.2919735 C40.6906339,38.277544 36.6830074,32.7398557 27.4975135,26.6718704 C27.0756167,26.3896422 27.4077248,25.7280471 27.8812776,25.9091318 C34.8463489,28.6132299 37.7789484,32.6596005 40.2114201,35.110133 C40.3891106,35.2889404 40.6424373,35.3712373 40.8914398,35.3313453 C41.1405209,35.2910606 41.355086,35.1336128 41.4675971,34.9079244 C42.6400393,32.6348643 44.46514,27.2649109 37.2711155,23.3556496 C30.9017002,19.896587 23.4747912,19.3435171 18.739656,19.2595006 C17.9244816,19.2464569 17.3802457,20.1119882 17.735312,20.8576864 C19.0623292,23.6608079 19.9731106,27.9628643 22.2451106,31.8968618 C26.9513907,40.0414312 32.7842752,40.6383195 38.1035872,38.578776 C38.4853857,38.4302802 38.9189975,38.5725723 39.1383587,38.9182508 C39.8543096,40.0241551 41.3073612,42.43456 41.6700541,44.2919735 C42.1607469,46.7862459 45.2137199,46.2178631 44.1195872,44.2919735 L44.1177789,44.2919735 Z" id="Fill-5" fill="#0095DD"></path>
																</g>
															</g>
														</g>
													</g>
												</g>
											</svg>
										</div>
										<div class="service-block-inner-content">
											<h3 class="service-item-title">Protects the Environment
											</h3>
											<div>
												<p>Safety materials is satisfy with International Standard and awarded ISO product quality certificate.</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
              <!-- Watch Our Story -->
			  <div class="section section-video background-img overlay-enabled" style="padding-bottom: 45px;">
					<div class="container">
						<div class="section-title-wrap">
							<h2 class="section-title">Watch Our Story</h2>
							<span class="divider"></span>
								<p class="section-subtitle">
									In what will be the next industry standard for furniture manufacturing,<br/>
									we are proud to be one of the first to employ a fully automated unmanned intelligent production line specifically designed for engineering. The entire process is digitally controlled by an advanced MES system. Every part of the manufacturing process can be monitored for uniform optimal results every time, thus eliminating problems caused by human error.
								</p>
						</div>
						<!-- <div class="media-zoom-icon"  @click="openVideo">
								<svg width="75px" height="75px" viewBox="0 0 75 75" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Page1-Home" transform="translate(-922.000000, -2862.000000)">
										<g id="part-4" transform="translate(0.000000, 2542.000000)">
											<g id="icon_play" transform="translate(922.000000, 320.000000)">
												<circle id="椭圆形" fill="#FFFFFF" cx="37.5" cy="37.5" r="37.5"></circle>
												<path d="M42.7149859,30.8583098 L51.1826051,44.9710085 C51.7509014,45.918169 51.4437713,47.1466895 50.4966108,47.7149859 C50.1857799,47.9014843 49.8301071,48 49.4676192,48 L32.5323808,48 C31.4278113,48 30.5323808,47.1045695 30.5323808,46 C30.5323808,45.6375121 30.6308964,45.2818393 30.8173949,44.9710085 L39.2850141,30.8583098 C39.8533105,29.9111492 41.081831,29.6040191 42.0289915,30.1723154 C42.3104907,30.3412149 42.5460863,30.5768105 42.7149859,30.8583098 Z" id="三角形" fill="#0095DD" transform="translate(41.000000, 38.000000) rotate(-270.000000) translate(-41.000000, -38.000000) "></path>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</div> -->
						<a class="media-zoom-icon"  rel="bookmark" target="_blank"  href="/static/images/tianjin.mp4">
								<svg width="75px" height="75px" viewBox="0 0 75 75" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Page1-Home" transform="translate(-922.000000, -2862.000000)">
										<g id="part-4" transform="translate(0.000000, 2542.000000)">
											<g id="icon_play" transform="translate(922.000000, 320.000000)">
												<circle id="椭圆形" fill="#FFFFFF" cx="37.5" cy="37.5" r="37.5"></circle>
												<path d="M42.7149859,30.8583098 L51.1826051,44.9710085 C51.7509014,45.918169 51.4437713,47.1466895 50.4966108,47.7149859 C50.1857799,47.9014843 49.8301071,48 49.4676192,48 L32.5323808,48 C31.4278113,48 30.5323808,47.1045695 30.5323808,46 C30.5323808,45.6375121 30.6308964,45.2818393 30.8173949,44.9710085 L39.2850141,30.8583098 C39.8533105,29.9111492 41.081831,29.6040191 42.0289915,30.1723154 C42.3104907,30.3412149 42.5460863,30.5768105 42.7149859,30.8583098 Z" id="三角形" fill="#0095DD" transform="translate(41.000000, 38.000000) rotate(-270.000000) translate(-41.000000, -38.000000) "></path>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</a>
					</div>
				</div>

              <!-- Projects -->
              <div class="section section-portfolio lite-background">
				<div class="container">
		·			<div class="section-title-wrap">
						<h2 class="section-title">Projects</h2>
						<span class="divider"></span>
						<p class="section-subtitle">To furnish many of the most desired luxury residential and commercial development in Singapore and Oversea </p>
					</div>
					<div class="portfolio-main-wrapper">
						<div class="masonry-wrapper portfolio-container">
							<div class="index_portfolio-item" v-for="(item,index) of project_images" :key="index">
								<div class="item-inner-wrapper">
									<img :src="item.img" class="portfolio-thumb">
									<div class="overlay"></div>
									<a class="zoom-icon" @click="projects_imgs_click(index)">
										 <svg width="99px" height="88px" viewBox="0 0 99 88" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
											<defs>
												<filter x="-6.4%" y="-12.8%" width="112.8%" height="125.7%" filterUnits="objectBoundingBox" id="filter-1">
													<feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
													<feGaussianBlur stdDeviation="17.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
													<feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.109211101 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
													<feMerge>
														<feMergeNode in="shadowMatrixOuter1"></feMergeNode>
														<feMergeNode in="SourceGraphic"></feMergeNode>
													</feMerge>
												</filter>
											</defs>
											<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
												<g id="Page1-Home" transform="translate(-518.000000, -4553.000000)">
													<g id="Part-6" transform="translate(0.000000, 3913.000000)">
														<g id="img" filter="url(#filter-1)" transform="translate(370.000000, 274.000000)">
															<g id="icon_check" transform="translate(180.000000, 392.000000)">
																<path d="M29.8771661,1.49978683 L33.8766441,1.49978683 L33.8766441,5.49926483 C33.8766441,5.91349778 34.2124997,6.24915825 34.6265376,6.24915825 C35.0405476,6.24915825 35.376431,5.91360923 35.376431,5.49926483 L35.376431,1.49978683 C35.376431,0.53504508 34.8413859,8.92619312e-14 33.8766441,8.92619312e-14 L29.8771661,8.92619312e-14 C29.4631282,8.92619312e-14 29.1272727,0.335632611 29.1272727,0.749893417 C29.1272727,1.16423781 29.4631282,1.49978683 29.8771661,1.49978683 Z" id="Fill-1" fill="#FFFFFF"></path>
																<path d="M0.753149111,6.24915825 C1.16918046,6.24915825 1.50629822,5.91327487 1.50629822,5.49926483 L1.50629822,1.49978683 L5.71149735,1.49978683 C6.12752871,1.49978683 6.46464646,1.16390346 6.46464646,0.749893417 C6.46464646,0.335855512 6.12752871,8.92619312e-14 5.71149735,8.92619312e-14 L1.69454352,8.92619312e-14 C0.725725237,8.92619312e-14 -2.22044605e-14,0.53504508 -2.22044605e-14,1.49978683 L-2.22044605e-14,5.49926483 C-2.22044605e-14,5.91327487 0.337117758,6.24915825 0.753149111,6.24915825 Z" id="Fill-2" fill="#FFFFFF"></path>
																<path d="M34.6265376,21.6 C34.2126111,21.6 33.8766441,21.9356545 33.8766441,22.34988 L33.8766441,26.3492867 L29.8771661,26.3492867 C29.4631282,26.3492867 29.1272727,26.6849412 29.1272727,27.0992782 C29.1272727,27.5135038 29.4631282,27.8491582 29.8771661,27.8491582 L33.8766441,27.8491582 C34.8413859,27.8491582 35.376431,27.3140113 35.376431,26.3493982 L35.376431,22.34988 C35.376431,21.9356545 35.0405476,21.6 34.6265376,21.6 Z" id="Fill-3" fill="#FFFFFF"></path>
																<path d="M5.73739718,26.372242 L1.58474779,26.372242 L1.58474779,22.4339725 C1.58474779,22.0262986 1.25195332,21.6955556 0.84101031,21.6955556 C0.430177841,21.6955556 0.0972728319,22.0262986 0.0972728319,22.4339725 L0.0972728319,26.372242 C0.0972728319,27.3222193 0.813929136,27.8490759 1.77064071,27.8490759 L5.73739718,27.8490759 C6.14822965,27.8490759 6.48113466,27.5183604 6.48113466,27.110659 C6.48113466,26.702985 6.14822965,26.372242 5.73739718,26.372242 Z" id="Fill-4" fill="#FFFFFF"></path>
																<rect id="矩形" stroke="#FFFFFF" x="15.6" y="12" width="4.8" height="4.8"></rect>
															</g>
														</g>
													</g>
												</g>
											</g>
										</svg>
										 </a>
									<div class="portfolio-content">
										<p>{{item.des}}</p>
									</div>
								</div>
							</div>

						</div>
					</div>
					<div class="more-wrapper" >
						<router-link :to="{path:'../projects'}" class="custom-button button-curved">
						<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
											<g id="Page1-Home" transform="translate(-901.000000, -4856.000000)" fill="#FFFFFF">
												<g id="Part-6" transform="translate(0.000000, 3913.000000)">
													<g id="button-more" transform="translate(866.000000, 927.000000)">
														<g id="编组-2" transform="translate(35.000000, 13.000000)">
															<path d="M10.1281191,10.3499782 L7.63440801,12.8437748 C7.45940774,13.018775 7.19688598,13.018775 7.02188571,12.8437748 C6.84682136,12.6687104 6.84682136,12.4062741 7.02188571,12.2312098 L8.81559573,10.4375211 L4.17811001,10.4375211 C3.91560961,10.4375211 3.74060935,10.2625208 3.74060935,9.99999907 C3.74060935,9.73749867 3.91560961,9.56249841 4.17811001,9.56249841 L8.77184566,9.56249841 L6.97809292,7.76872431 C6.80311402,7.5937454 6.80311402,7.33122364 6.97809292,7.15624474 C7.15315728,6.98124447 7.41559359,6.98124447 7.5905725,7.15624474 L10.0843904,9.64993445 C10.2156406,9.78120602 10.2156406,9.91247758 10.2593907,9.95627037 C10.2593907,10.0874778 10.2156406,10.2625208 10.1281191,10.3499782 M6.99998932,3.00000976 C3.15002617,3.00000976 0,6.15003592 0,9.99999907 C0,13.8499836 3.15002617,17.0000098 6.99998932,17.0000098 C10.8499738,17.0000098 14,13.8499836 14,9.99999907 C14,6.15003592 10.8499738,3.00000976 6.99998932,3.00000976" id="icon_jiantou"></path>
														</g>
													</g>
												</g>
											</g>
										</g>
									</svg>
						Explore More</router-link>
					</div>
				</div>
              </div>
              <!--Our Partners  -->
                <div class="section section-portfolio">
					<div class="container">
						<div class="section-title-wrap">
							<h2 class="section-title">Our Partners</h2>
							<span class="divider"></span>
							<p class="section-subtitle">Through our concerted efforts and close cooperation, we have built great relationship with local and oversea developers and other well-known suppliers</p>
						</div>
					<div>
                    <img src="../assets/images/index/img_home_partners.png">
                </div>
				</div>
              </div>
              <!-- GET IN TOUCH -->
              <div  class="section section-quick-contact background-img overlay-enabled">
				<div class="container">
					  <div class="tip">
                <div class="tipMessaage success" v-if="tipMessage_success">
                  <span>
                    <svg
                      class="icon"
                      width="64px"
                      height="64px"
                      viewBox="0 0 64 64"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="邮箱界面"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="提交弹窗"
                          transform="translate(-272.000000, -158.000000)"
                          fill="#38D993"
                        >
                          <g
                            id="overlay"
                            transform="translate(46.000000, 119.000000)"
                          >
                            <path
                              d="M258.000157,39 C240.40011,39 226,53.4001096 226,70.9998434 C226,88.5999687 240.40011,103 258.000157,103 C275.600204,103 290,88.5999687 290,70.9998434 C290,53.2667854 275.733606,39 258.000157,39 Z M258.000157,99.0000391 C242.533453,99.0000391 230.000039,86.4666249 230.000039,70.9998434 C230.000039,55.5334534 242.533453,43.0000391 258.000157,43.0000391 C273.46686,43.0000391 285.999961,55.5334534 285.999961,70.9998434 C285.999961,86.4666249 273.46686,99.0000391 258.000157,99.0000391 Z M277.59991,57.0000979 C276.666954,56.2000744 275.333555,56.3333986 274.666621,57.1334221 L254.800141,79.1332459 L243.466723,69.8001605 C242.533453,69.1334612 241.333379,69.2668637 240.533434,70.0668089 C239.866735,70.9998434 239.866735,72.2001527 240.800082,73.0001761 L253.733469,83.6665819 C254.133442,83.9335434 254.533493,84.0666327 254.933465,84.0666327 L255.333516,84.0666327 C255.866813,84.0666327 256.266785,83.7999061 256.666836,83.3999335 L277.733312,60.0667893 C278.533258,59.1334416 278.399933,57.8001213 277.59991,57.0000979 Z"
                              id="chenggong"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  Success!
                </div>
                <div class="tipMessaage error" v-if="tipMessage_error">
                  <span>
                    <svg
                      class="icon"
                      width="64px"
                      height="64px"
                      viewBox="0 0 64 64"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="邮箱界面"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="提交弹窗备份"
                          transform="translate(-131.000000, -155.000000)"
                          fill="#FF5A5A"
                        >
                          <g
                            id="overlay"
                            transform="translate(45.000000, 117.000000)"
                          >
                            <path
                              d="M130.82607,57.1388515 C130.403726,56.7173666 129.8306,56.4808819 129.233725,56.4820495 C128.636771,56.4833038 128.064895,56.7216635 127.643723,57.1449452 L118.000195,66.8116758 L108.356277,57.1449452 C107.480104,56.2641629 106.055884,56.261116 105.175414,57.1376015 C104.295022,58.0137744 104.291663,59.4379949 105.168148,60.3184647 L114.829098,70.0001953 L105.170883,79.6815353 C104.294397,80.5620051 104.297757,81.9862256 105.178148,82.8623985 C106.058618,83.738884 107.482839,83.7358371 108.359324,82.8553673 L118.000195,73.1883242 L127.643723,82.8612266 C128.063645,83.2866178 128.636146,83.5264618 129.233725,83.5274042 C129.831538,83.5286493 130.404664,83.2909147 130.82607,82.8670079 C131.70779,81.9941943 131.70779,80.5687238 130.83193,79.6873946 L121.17098,70.0001953 L130.823336,60.3184647 C131.245446,59.8972924 131.482868,59.3254167 131.482868,58.7287753 C131.482868,58.132134 131.245446,57.5602583 130.823336,57.1388515 L130.82607,57.1388515 Z M118.000195,38 C100.324392,38 86,52.3243925 86,70.0001953 C86,87.6756856 100.324392,102 118.000195,102 C135.675686,102 150,87.6756856 150,70.0001953 C150,52.3243925 135.675686,38 118.000195,38 Z M137.444438,89.4444378 C134.939278,91.9575659 131.969275,93.9592089 128.699661,95.3383512 C125.315517,96.7732749 121.675981,97.5087445 118.000195,97.4999949 C114.324956,97.5074945 110.685733,96.7744467 107.300417,95.3441325 C104.032835,93.9613964 101.063456,91.9599877 98.5555622,89.4502191 C96.0424341,86.9450597 94.0407911,83.9750561 92.6619613,80.7054428 C91.2273501,77.3191886 90.492193,73.6778561 90.5003282,70.0001953 C90.5003282,66.2880033 91.2276626,62.6865926 92.6558675,59.3004166 C94.0386817,56.0328345 96.0400123,53.0634559 98.5497809,50.5555622 C101.05494,48.0424341 104.024944,46.0407911 107.294557,44.6619613 C110.680811,43.2273501 114.322456,42.492193 118.000195,42.5003282 C121.711997,42.5003282 125.313407,43.2276626 128.699661,44.6558675 C131.967165,46.0386817 134.936544,48.0400123 137.444438,50.5497809 C139.957566,53.0549403 141.959209,56.0249439 143.338351,59.2945572 C144.77265,62.6808114 145.50812,66.3224564 145.499984,70.0001953 C145.516088,77.2972355 142.614757,84.2979471 137.441703,89.4444378 L137.444438,89.4444378 Z"
                              id="shibai"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  Network error, please reload the page and try again.
                </div>
              </div>
					<div class="inner-wrapper">
						<div class="col-grid-7">
							<div class="section-title-wrap text-alignleft">
								<h2 class="section-title">Get In Touch</h2>
								<span class="divider"></span>
								<p class="welcome" style="font-size:18px">Welcome to contact us for more information.</p>
							</div>
						<div class="quick-contact-widget">
							<div class="quick-contact-item">
							<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<g id="Page1-Home" transform="translate(-371.000000, -6003.000000)">
											<g id="Part-8" transform="translate(0.000000, 5675.000000)">
												<g id="get-in-touch" transform="translate(370.000000, 128.000000)">
													<g id="icon_Phone" transform="translate(2.000000, 201.000000)">
														<path d="M18.3277738,14 C16.7634041,14.5974002 15.540517,15.8494104 15,17.4334882 C15,20.2601702 16.8406379,25.9688987 21.031073,30.1709405 C25.4585646,34.6100374 31.2498441,36.3947368 34.5489379,36.3947368 C36.2459972,36.1860784 37.6301945,34.9340682 38,33.2645625 C36.3408435,31.7089408 34.454151,30.4189494 32.4064459,29.4420944 C32.0082579,29.5179378 31.6288725,29.669684 31.2783456,29.8879865 C30.5576562,30.333581 29.7423585,30.5897457 28.8984998,30.6371924 C26.7654686,30.6371924 20.7547453,24.6233642 20.7547453,22.4893925 C20.7831873,21.6165394 21.0676668,20.7629745 21.5794444,20.0516903 C21.7406355,19.8239818 21.8638644,19.5773421 21.9397891,19.3021868 C21.0676668,17.3481198 19.8351999,15.5460966 18.3277738,14" id="Fill-3" fill="#FFFFFF"></path>
														<circle id="椭圆形" stroke="#FFFFFF" stroke-width="2" cx="26" cy="26" r="26"></circle>
													</g>
												</g>
											</g>
										</g>
									</g>
								</svg>
							<div class="text_left"> +65 6518 9877</div>
						</div>
							<div class="quick-contact-item">
							<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Page1-Home" transform="translate(-371.000000, -6095.000000)">
										<g id="Part-8" transform="translate(0.000000, 5675.000000)">
											<g id="get-in-touch" transform="translate(370.000000, 128.000000)">
												<g id="icon_Email" transform="translate(2.000000, 293.000000)">
													<path d="M35.9813255,20.3179267 L25.8686316,25.6689997 L16.0078944,20.4493016 C16.1035225,19.0824369 17.3427071,18 18.8578963,18 L33.1421037,18 C34.6094623,18 35.819524,19.0118697 35.9813255,20.3179267 Z M36,22.234675 L36,30.3804066 C36,31.8276894 34.7208791,33 33.1421037,33 L18.8578963,33 C17.2789882,33 16,31.8276894 16,30.3804066 L16,22.373286 L25.4175909,27.3571416 C25.7412602,27.5273118 26.1313684,27.4957222 26.4126801,27.3059415 C26.4258816,27.3011985 26.4365291,27.2938408 26.4497306,27.2865743 L36,22.234675 Z" id="Fill-1" fill="#FFFFFF"></path>
													<circle id="椭圆形备份-2" stroke="#FFFFFF" stroke-width="2" cx="26" cy="26" r="26"></circle>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
							<div class="text_left">info@pearlriverdecoration.com</div>
						</div>
							<div class="quick-contact-item">
							<svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Page1-Home" transform="translate(-371.000000, -6187.000000)">
										<g id="Part-8" transform="translate(0.000000, 5675.000000)">
											<g id="get-in-touch" transform="translate(370.000000, 128.000000)">
												<g id="icon_Adress" transform="translate(2.000000, 385.000000)">
													<path d="M26.0093684,25.1505958 L25.9944127,25.1505958 C24.160662,25.1505958 22.6711975,23.6612533 22.6711975,21.8275027 C22.6711975,19.9939351 24.160662,18.5044633 25.9944127,18.5044633 L26.00186,18.5044633 C27.8354886,18.5006858 29.3249532,19.9864268 29.3286769,21.823779 C29.3286769,23.6575297 27.842997,25.1468111 26.0093684,25.1505958 M26.0000287,14 C23.6094991,14 21.3216449,14.950022 19.6357419,16.6402591 C17.949961,18.3306183 17,20.6229287 17,23.0090021 C17,26.5991001 21.6783839,33.7482249 24.2873886,36.8300737 C24.7110314,37.3339889 25.3355078,37.6239461 25.9955725,37.6239461 L26.0044849,37.6239461 C26.6645497,37.6239461 27.2889039,37.3339889 27.7125467,36.8300737 C30.3215515,33.7482249 35,26.594644 35,23.0090021 C35.0043916,18.0362049 30.9727039,14 26.0000287,14" id="Fill-3" fill="#FFFFFF"></path>
													<circle id="椭圆形备份" stroke="#FFFFFF" stroke-width="2" cx="26" cy="26" r="26"></circle>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
							<div class="text_left">2 Sims Close, #07-09, Singapore 387298</div>
						</div>
					</div>
						</div>
						<div class="col-grid-5">
							<div class="contact-form-area contactdesc">
								<h3 class="contact-title">Contact Us</h3>
								<div id="contact-form" class="contact-form">
									<div id="message"></div>
									<div id="contactform" name="contactform">
											<div class="control_all">
											<input
											type="text"
											v-model="name"
											:class="{formControl:nameTipShow}"
											placeholder="Name *"
											/>
											<span v-show="nameTipShow">mandatory field.</span>
											</div>
											<div class="control_all">
												<input
												type="text"
												v-model="email"
												:class="{formControl:emailTipShow}"
												placeholder="Email *"
												/>
												<span v-show="emailTipShow"
												>mandatory field.</span
												>
											</div>
											<div class="control_all">
												<input
												type="text"
												v-model="contactNumber"
												class="form-control"
												placeholder="Cantact Number"
												/>
											</div>
											<div class="control_all">
												<textarea
												:class="{formControl:desc_contentTipShow}"
												name="comments"
												v-model="desc_content"
												rows="3"
											></textarea>
												<span v-show="desc_contentTipShow"
												>mandatory field.</span
												>
											</div>
										<div type="submit" class="button-curved sumitbtn" @click="submit_contactus">Submit</div>
									</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			 </div>
              <!-- foot -->
               <main-foot></main-foot>
            </div>
          </div>
        </div>
      </div>
    </div>
   <!--#page-->
   <PageScroller></PageScroller>
   <PrettyPhoto
      v-if="show_img"
      @close="close"
      :imgs="imgs"
	  :imgIndex='imgIndex'
      :photo_text="photo_text"
    ></PrettyPhoto>
	 <div class="tipMessaage success" v-if="tipMessage_success">
      <span>
        <svg
          width="64px"
          height="64px"
          viewBox="0 0 64 64"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="邮箱界面"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="提交弹窗"
              transform="translate(-272.000000, -158.000000)"
              fill="#38D993"
            >
              <g id="overlay" transform="translate(46.000000, 119.000000)">
                <path
                  d="M258.000157,39 C240.40011,39 226,53.4001096 226,70.9998434 C226,88.5999687 240.40011,103 258.000157,103 C275.600204,103 290,88.5999687 290,70.9998434 C290,53.2667854 275.733606,39 258.000157,39 Z M258.000157,99.0000391 C242.533453,99.0000391 230.000039,86.4666249 230.000039,70.9998434 C230.000039,55.5334534 242.533453,43.0000391 258.000157,43.0000391 C273.46686,43.0000391 285.999961,55.5334534 285.999961,70.9998434 C285.999961,86.4666249 273.46686,99.0000391 258.000157,99.0000391 Z M277.59991,57.0000979 C276.666954,56.2000744 275.333555,56.3333986 274.666621,57.1334221 L254.800141,79.1332459 L243.466723,69.8001605 C242.533453,69.1334612 241.333379,69.2668637 240.533434,70.0668089 C239.866735,70.9998434 239.866735,72.2001527 240.800082,73.0001761 L253.733469,83.6665819 C254.133442,83.9335434 254.533493,84.0666327 254.933465,84.0666327 L255.333516,84.0666327 C255.866813,84.0666327 256.266785,83.7999061 256.666836,83.3999335 L277.733312,60.0667893 C278.533258,59.1334416 278.399933,57.8001213 277.59991,57.0000979 Z"
                  id="chenggong"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </span>
      success
    </div>
    <div class="tipMessaage error" v-if="tipMessage_error">
      <span>
        <svg
          width="64px"
          height="64px"
          viewBox="0 0 64 64"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="邮箱界面"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="提交弹窗备份"
              transform="translate(-131.000000, -155.000000)"
              fill="#FF5A5A"
            >
              <g id="overlay" transform="translate(45.000000, 117.000000)">
                <path
                  d="M130.82607,57.1388515 C130.403726,56.7173666 129.8306,56.4808819 129.233725,56.4820495 C128.636771,56.4833038 128.064895,56.7216635 127.643723,57.1449452 L118.000195,66.8116758 L108.356277,57.1449452 C107.480104,56.2641629 106.055884,56.261116 105.175414,57.1376015 C104.295022,58.0137744 104.291663,59.4379949 105.168148,60.3184647 L114.829098,70.0001953 L105.170883,79.6815353 C104.294397,80.5620051 104.297757,81.9862256 105.178148,82.8623985 C106.058618,83.738884 107.482839,83.7358371 108.359324,82.8553673 L118.000195,73.1883242 L127.643723,82.8612266 C128.063645,83.2866178 128.636146,83.5264618 129.233725,83.5274042 C129.831538,83.5286493 130.404664,83.2909147 130.82607,82.8670079 C131.70779,81.9941943 131.70779,80.5687238 130.83193,79.6873946 L121.17098,70.0001953 L130.823336,60.3184647 C131.245446,59.8972924 131.482868,59.3254167 131.482868,58.7287753 C131.482868,58.132134 131.245446,57.5602583 130.823336,57.1388515 L130.82607,57.1388515 Z M118.000195,38 C100.324392,38 86,52.3243925 86,70.0001953 C86,87.6756856 100.324392,102 118.000195,102 C135.675686,102 150,87.6756856 150,70.0001953 C150,52.3243925 135.675686,38 118.000195,38 Z M137.444438,89.4444378 C134.939278,91.9575659 131.969275,93.9592089 128.699661,95.3383512 C125.315517,96.7732749 121.675981,97.5087445 118.000195,97.4999949 C114.324956,97.5074945 110.685733,96.7744467 107.300417,95.3441325 C104.032835,93.9613964 101.063456,91.9599877 98.5555622,89.4502191 C96.0424341,86.9450597 94.0407911,83.9750561 92.6619613,80.7054428 C91.2273501,77.3191886 90.492193,73.6778561 90.5003282,70.0001953 C90.5003282,66.2880033 91.2276626,62.6865926 92.6558675,59.3004166 C94.0386817,56.0328345 96.0400123,53.0634559 98.5497809,50.5555622 C101.05494,48.0424341 104.024944,46.0407911 107.294557,44.6619613 C110.680811,43.2273501 114.322456,42.492193 118.000195,42.5003282 C121.711997,42.5003282 125.313407,43.2276626 128.699661,44.6558675 C131.967165,46.0386817 134.936544,48.0400123 137.444438,50.5497809 C139.957566,53.0549403 141.959209,56.0249439 143.338351,59.2945572 C144.77265,62.6808114 145.50812,66.3224564 145.499984,70.0001953 C145.516088,77.2972355 142.614757,84.2979471 137.441703,89.4444378 L137.444438,89.4444378 Z"
                  id="shibai"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </span>
      Network error, please reload the page and try again.
    </div>
  </div>
</template>
<script>
import MainHeader from "../components/MainHeader";
import MainFoot from "../components//MainFoot";
import PrettyPhoto from "../components/PrettyPhoto";
import PageScroller from "../components/PageScroller";

import img1 from "../assets/images/project/GRAND DUNMAN/0.png";
import img2 from "../assets/images/project/HILLHAVEN/0.png";
import img3 from "../assets/images/project/MAYFAIR MODERN/0.png";
import img4 from "../assets/images/project/NORMANTON PARK/0.png";
import img5 from "../assets/images/project/PROVENCE/0.png";
import img6 from "../assets/images/project/THE COMMODORE/0.png";
const index_imgs = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
];
export default {
  name: "index",
  created() {
    let self = this;
  },
  data() {
    return {
      tipMessage_error: false,
      tipMessage_success: false,
      imgIndex: 0,
      show_img: false,
      imgs: index_imgs,
      project_images: [
        {
          img: img1,
          des: "GRAND DUNMAN",
        },
        {
          img: img2,
          des: "HILLHAVEN",
        },
        {
          img: img3,
          des: "MAYFAIR MODERN",
        },
        {
          img: img4,
          des: "NORMANTON PARK",
        },
        {
          img: img5,
          des: "PROVENCE",
        },
        {
          img: img6,
          des: "THE COMMODORE",
        },
      ],
      photo_text: "",
      name: "",
      email: "",
      contactNumber: "",
      nameTipShow: "",
      desc_content: "",
      desc_contentTipShow: false,
      emailTipShow: false,
      swiperOption: {
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        slidesPerView: 1,
        effect: "fade",
        autoplay: {
          delay: 1000,
          disableOninteraction: false,
        },
        loop: true,
      },
    };
  },

  methods: {
    moreTeam() {
      window.open("http://www.homing.sg/#/aboutus");
    },
    projects_imgs_click(val) {
      this.show_img = true;
      if (val == 5) {
        this.imgIndex = 3;
      } else if (val == 3) {
        this.imgIndex = 4;
      } else if (val == 4) {
        this.imgIndex = 5;
      } else {
        this.imgIndex = val;
      }
    },
    close(e) {
      this.show_img = e;
      // this.imgs = this.project_images;
    },
    getPath() {
      debugger;
      console.log("fsdfdsfsdf");
      window.localStorage.clear();
      window.location.reload();
    },
    openVideo() {
      this.VideoShow = true;
    },
    submit_contactus() {
      let self = this;
      if (self.name.length == 0) {
        self.nameTipShow = true;
        return;
      } else {
        self.nameTipShow = false;
      }
      if (self.email.length == 0) {
        self.emailTipShow = true;
        return;
      } else {
        self.emailTipShow = false;
      }
      if (self.desc_content.length == 0) {
        self.desc_contentTipShow = true;
        return;
      } else {
        self.desc_contentTipShow = false;
      }
      this.$http
        .get("http://sendmail.justtruth.cn/email_send_template", {
          params: {
            name: self.name,
            email: self.email,
            contactNumber: self.contactNumber,
            desc_content: self.desc_content,
            subject: "【 PEARL RIVER  】 A letter from " + self.name,
            recipient: "info@pearlriverdecoration.com",
            //recipient: "yangliying@justtruth.cn",
            //recipient: "1131043510@qq.com",
            template: "sgEmail",
          },
        })
        .then((res) => {
          self.tipMessage_success = true;
          setTimeout(function () {
            self.tipMessage_success = false;
          }, 3000);
          (self.name = ""),
            (self.email = ""),
            (self.contactNumber = ""),
            (self.desc_content = "");
        })
        .catch((err) => {
          self.tipMessage_error = true;
          setTimeout(function () {
            self.tipMessage_error = false;
          }, 3000);
          (self.name = ""),
            (self.email = ""),
            (self.contactNumber = ""),
            (self.desc_content = "");
          console.log(err);
        });
    },
  },
  components: {
    MainHeader,
    MainFoot,
    PrettyPhoto,
    PageScroller,
  },
  //   destroyed() {
  //     //this.reload();
  //     document.body.remove(this.$refs.index);
  //     location.reload();
  //   },
};
</script>

<style rel="stylesheet/less" type="text/less" lang="less"  scoped>
.tip {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -60px;
  .tipMessaage {
    width: 660px;
    height: 100px;
    border-radius: 10px;
    font-size: 18px;
    display: flex;
    align-items: center;
    text-align: left;
    padding-left: 38px;
    span {
      margin-right: 30px;
    }
  }

  .success {
    color: #38d993;
    background-color: #f5fff5;
    box-shadow: 0px 6px 15px 0px rgba(59, 74, 116, 0.22);
    border: solid 1px #38d993;
  }
  .error {
    color: #ff5a5a;
    background-color: #fff3f3;
    box-shadow: 0px 9px 15px 0px rgba(59, 74, 116, 0.21);
    border: solid 1px #ff5a5a;
    div {
      width: 417px;
      text-align: left;
    }
  }
  .icon {
    width: 32px;
    height: 32x;
  }
}
.sumitbtn {
  background: #0095dd;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  padding: 10px 35px;
  border: none;
  height: auto;
  outline: none;
  width: auto;
  cursor: pointer;
  display: inline-block;
  &:hover {
    background-color: #222;
    color: #fff;
    outline: none;
  }
}
.formControl {
  border: 1px solid #e70000;
}
.portfolio-container {
  margin-top: 30px;
}
.welcome {
  font-size: 18px;
  margin-bottom: 35px;
}
.color272727 {
  color: #272727;
}
.section-services .service-block-inner_f {
  padding: 50px 20px;
}
.section-services .service-item-title {
  margin: 30px 0;
}
.service-block-item-excerpt {
  margin: 0 24px;
}
.section-featured-slider .featrued-slider:after {
  content: "";
  display: block;
  background: rgba(0, 17, 44, 0.4);
  height: 100%;
  width: 100%;
  top: 0;
  position: absolute;
  z-index: 1;
  left: 0;
}
</style>
